import styled from 'styled-components';

// Hole on the left side of the boarding pass
const StyledSide = styled.div`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 90%;
  width: 50px;
  height: 90px;
  box-shadow: inset -10px 1px 4px -3px rgba(0, 0, 0, 0.1);

  // move and rotate the hole to the top
  @media (max-width: 768px) {
    left: 50%;
    top: 0;
    width: 90px;
    height: 50px;
    box-shadow: inset 0px -9px 4px -3px rgba(0, 0, 0, 0.1);
  }
`;

// Hole on the right side of the boarding pass
const StyledSideRight = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(50%, -50%);
  background-color: white;
  border-radius: 90%;
  width: 50px;
  height: 90px;
  box-shadow: inset 10px 1px 4px -3px rgba(0, 0, 0, 0.1);

  // move and rotate the hole to the bottom
  @media (max-width: 768px) {
    left: 50%;
    top: 100%;
    width: 90px;
    height: 50px;
    transform: translate(-50%, -50%);
    box-shadow: inset 0px 11px 4px -3px rgba(0, 0, 0, 0.1);
  }
`;

const StyledBoardingPass = styled.div<{ $betweenFlight: boolean }>`
  margin: ${(props) => (props.$betweenFlight ? '0 15rem' : '0')};
  position: relative;
  display: flex;
  flex-direction: row;
  min-width: 300px;

  @media (max-width: 1024px) {
    margin: ${(props) => (props.$betweenFlight ? '0 10rem' : '0')};
  }

  @media (max-width: 900px) {
    margin: ${(props) => (props.$betweenFlight ? '0 5rem' : '0')};
  }

  @media (max-width: 768px) {
    margin: 0;
  }
`;
const StyledBody = styled.div<{ $betweenFlight: boolean }>`
  display: ${(props) => (props.$betweenFlight ? 'block' : 'grid')};
  width: 100%;
  grid-template-columns: 1fr 1fr;
  @media (max-width: 768px) {
    grid-template-columns: none;
    grid-template-rows: 1fr 1fr;
  }
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
`;

const StyledFlight = styled.div<{ $side: 'right' | 'left'; $betweenFlight: boolean }>`
  padding: 25px 25px 0px 25px;
  ${(props) => (props.$side === 'right' ? 'padding-right: 45px;' : '')}
  ${(props) => (props.$side === 'left' ? 'padding-left: 45px;' : '')}
  background-color: white;
  ${(props) => (props.$side === 'left' && !props.$betweenFlight ? 'border-right: 2px dashed rgba(0,0,0,0.1);' : '')}

  @media (max-width: 768px) {
    border-right: unset;
    ${(props) => (props.$side === 'left' && !props.$betweenFlight ? 'border-bottom: 2px dashed rgba(0,0,0,0.1);' : '')}
  }
`;

const StyledAirline = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 1rem;
  padding-bottom: 1rem;
`;

const StyledAirlineLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  max-height: 92px;
  max-width: 92px;
`;
const StyledAirlineInfo = styled.div`
  display: flex;
  flex-direction: column;
  & > p {
    margin: 0.1rem 0;
  }
`;
const StyledDepartureOrArrival = styled.div``;

const StyledTripWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2rem;
`;

const StyledTripLayovers = styled.div`
  margin-top: 0.5rem;
`;
const StyledTripTiming = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const StyledTripTimingTime = styled.div`
  background-color: ${(props) => props.theme.color.primaryTransparent};
  color: ${(props) => props.theme.color.primary};
  padding: 0.25rem 0.75rem;
  border-radius: 3px;
  p {
    display: flex;
    justify-content: center;
    gap: 0.25rem;
  }
`;
const StyledTripTimingLine = styled.div`
  position: relative;
  margin-top: 0.75rem;
  width: 80%;
  height: 0px;
  border-bottom: 2px dashed ${(props) => props.theme.color.primary};
`;
const StyledTripTimingLineDot = styled.div<{
  $totalDots: number;
  $index: number;
}>`
  position: absolute;
  left: ${(props) => `${(props.$index / (props.$totalDots - 1)) * 100}%`};
  top: 1px;
  width: 12px;
  height: 12px;
  border-radius: 100%;
  transform: translate(-50%, -50%);
  background-color: ${(props) => props.theme.color.primary};
`;
const StyledFooter = styled.div`
  display: flex;
  justify-content: end;
  padding-top: 45px;
  padding-bottom: 35px;
`;

export {
  StyledSide,
  StyledSideRight,
  StyledBoardingPass,
  StyledBody,
  StyledFlight,
  StyledAirline,
  StyledAirlineLogoWrapper,
  StyledAirlineInfo,
  StyledDepartureOrArrival,
  StyledTripWrapper,
  StyledTripLayovers,
  StyledTripTiming,
  StyledTripTimingTime,
  StyledTripTimingLine,
  StyledTripTimingLineDot,
  StyledFooter,
};
